import { render, staticRenderFns } from "./ProspectTable.vue?vue&type=template&id=53396766"
import script from "./ProspectTable.vue?vue&type=script&lang=js"
export * from "./ProspectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports